import { render, staticRenderFns } from "./InviteUser.vue?vue&type=template&id=32a8051e&"
import script from "./InviteUser.vue?vue&type=script&lang=js&"
export * from "./InviteUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports